<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[3476]')" width="200"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[585]')" width="200"></el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="12">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="50%"
                   :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[3476]')}}</td>
                        <td>
                            <routejump :urlNo="15" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="dataList.workcenter_code"
                                    type="text"
                                    readonly
                                    class="mcolor"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectWorkCenter()"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[585]')}}</td>
                        <td>
                            <el-input v-model="dataList.workcenter_name" :disabled="true"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading"
                           :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetWorkCenterPopupList'" @callback="getWorkCenter" ref="workcenter"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: '2_workcenter',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList:[],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('2_workcenter'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectData: [],
                ids: "",
                btn: {
                    del: false,
                    edit: false
                },
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6335]"),this.$t("getapi[20]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if(that.selectData.length>0){
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del')
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh')
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.edit = true;
                that.btn.del = true;
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('2_workcenter',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true
                that.dataList = {
                    old_workcenter_code: row.workcenter_code,
                    workcenter_code: row.workcenter_code,
                    workcenter_name: row.workcenter_name,
                }
                that.oldDataList=JSON.stringify(that.dataList)
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
//                    if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
//                    }
                });
                that.$http.urlpost('/Pro/SchPro/GetAllAPSWorkCenterView', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let parm = that.dataList
                that.$http.urlpost('/Pro/SchPro/SaveAPSWorkCenter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            // 删除
            delf() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        workcenter_code: that.selectData[i].workcenter_code
                    }]
                }
                let parm = {
                    list: arr
                };
                that.$http.urlpost('/Pro/SchPro/DelAPSWorkCenter', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            // 删除
            del(row) {
                let that = this
                let parm = {
                    list: [{
                        workcenter_code: row.row.workcenter_code
                    }]
                }
                that.$http.urlpost('/Pro/SchPro/DelAPSWorkCenter', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            //批量删除
            batchDel() {
                let that = this;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    old_workcenter_code:'',
                    workcenter_code: '',
                    workcenter_name: '',
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            selectWorkCenter(){
                let that = this;
                that.$refs.workcenter.clearInput(true);
            },
            getWorkCenter(val){
                let that = this;
                console.log(val)
                that.dataList.workcenter_code = val.workcenter_code;
                that.dataList.workcenter_name = val.workcenter_name
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
